
import Model from './Model'

const ImportanceLevels = {
    NiceToHave: 1,
    Important: 2,
    VeryImportant: 3,
};

export default class TalentSkill extends Model
{
	static Key = 'TalentSkill';
	
	static ImportanceLevels = ImportanceLevels;
	
	static MaxScore = 5;

	static importanceLevelMultiplier(importance) {
		return laravel.importance_level_multipliers[importance] || 0;
	}

	static veryImportantLevelMultiplier() {
		return this.importanceLevelMultiplier(ImportanceLevels.VeryImportant);
	}

	static importantLevelMultiplier() {
		return this.importanceLevelMultiplier(ImportanceLevels.Important);
	}

	static niceToHaveLevelMultiplier() {
		return this.importanceLevelMultiplier(ImportanceLevels.NiceToHave);
	}
}